// extracted by mini-css-extract-plugin
module.exports = {"container":"DietsPageIconsWrapper_container__1ooCX","container__title":"DietsPageIconsWrapper_container__title__3oJmN","wrapper":"DietsPageIconsWrapper_wrapper__1EeDD"};